const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "Monika Bandelewska - Kancelaria Radcy Prawnego", // <title>
  shortSiteTitle: "MB - KRP", // <title> ending for posts and pages
  siteDescription: "Strona kancelarii radcy prawnego Monika Bandelewska",
  siteUrl: "https://mb-krp.pl",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "pl",
  // author
  authorName: "Monika Bandelewska",
  authorTwitterAccount: "",
  // info
  infoTitle: "Monika Bandelewska",
  infoTitleNote: "Kancelaria Radcy Prawnego",
  // manifest.json
  manifestName: "Monika Bandelewska - Kancelaria Radcy Prawnego",
  manifestShortName: "MB-KRP", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "kancelaria@mb-krp.pl",
  // social
  authorSocialLinks: []
};



// WEBPACK FOOTER //
// ./content/meta/config.js